var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTiktokIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5251 0.02C12.8351 0 14.1351 0.01 15.4351 0C15.5151 1.53 16.0651 3.09 17.1851 4.17C18.3051 5.28 19.8851 5.79 21.4251 5.96V9.99C19.9851 9.94 18.5351 9.64 17.2251 9.02C16.6551 8.76 16.1251 8.43 15.6051 8.09C15.5951 11.01 15.6151 13.93 15.5851 16.84C15.5051 18.24 15.0451 19.63 14.2351 20.78C12.9251 22.7 10.6551 23.95 8.32512 23.99C6.89512 24.07 5.46512 23.68 4.24512 22.96C2.22512 21.77 0.80512 19.59 0.59512 17.25C0.57512 16.75 0.56512 16.25 0.58512 15.76C0.76512 13.86 1.70512 12.04 3.16512 10.8C4.82512 9.36 7.14512 8.67 9.31512 9.08C9.33512 10.56 9.27512 12.04 9.27512 13.52C8.28512 13.2 7.12512 13.29 6.25512 13.89C5.62512 14.3 5.14512 14.93 4.89512 15.64C4.68512 16.15 4.74512 16.71 4.75512 17.25C4.99512 18.89 6.57512 20.27 8.25512 20.12C9.37512 20.11 10.4451 19.46 11.0251 18.51C11.2151 18.18 11.4251 17.84 11.4351 17.45C11.5351 15.66 11.4951 13.88 11.5051 12.09C11.5151 8.06 11.4951 4.04 11.5251 0.02Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktokIcon);
export default __webpack_public_path__ + "static/media/tiktok-icon.f2d7510d6953887bfb11e4c263aeed0d.svg";
export { ForwardRef as ReactComponent };